import { useEffect, useState } from 'react';

interface UseAnimationStateOptions {
  enterDelay?: number;
  exitDelay?: number;
}

export const useAnimationState = (isOpen: boolean, options: UseAnimationStateOptions = {}) => {
  const { enterDelay = 10, exitDelay = 300 } = options;
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      // Pequeño delay para que el DOM se actualice antes de animar
      const timer = setTimeout(() => {
        setIsAnimating(true);
      }, enterDelay);
      return () => clearTimeout(timer);
    } else {
      setIsAnimating(false);
      const timeout = setTimeout(() => setIsVisible(false), exitDelay);
      return () => clearTimeout(timeout);
    }
  }, [isOpen, enterDelay, exitDelay]);

  return { isVisible, isAnimating };
};
